import { createFileRoute } from '@tanstack/react-router';

import { InvalidTokenPage } from '@/pages/invalid-token.page';

export const Route = createFileRoute('/invalid-token')({
  component: InvalidTokenPage,
});
